import { useEffect, useState } from "react";

export default function useSolPrice() {
  const [solPrice, setSolPrice] = useState(null);

  useEffect(() => {
    let alive = true;

    const fetchPrice = async () => {
      try {
        const res = await fetch("/.netlify/functions/solPrice", {
          cache: "no-store",
        });
        const data = await res.json();

        if (data.price > 0 && alive) {
          setSolPrice(data.price);
        }
      } catch (err) {
        console.error("SOL price fetch failed", err);
      }
    };

    fetchPrice();
    const i = setInterval(fetchPrice, 5_000);

    return () => {
      alive = false;
      clearInterval(i);
    };
  }, []);

  return solPrice;
}
